import { ChipsOption } from 'shared/models/ChipsOption';
import { SliderBlockTypeOneSlideService } from 'shared/services/ChipsDataService';

import { SliderBlockTypeOneModel } from '../../external/models/SliderBlockTypeOneModel';
import { SliderBlockTypeOneSlideModel } from '../models/SliderBlockTypeOneSlideModel';

export const sliderBlockTypeOneSlideServiceV1 = new SliderBlockTypeOneSlideService([
  new SliderBlockTypeOneModel(new ChipsOption('Благоустройство'), [
    new SliderBlockTypeOneSlideModel(
      'Дворы-парки',
      'Дворы-парки разрабатываются при участии профессиональных дизайнеров и дендрологов. В оформлении мы используем натуральные материалы и растения, устойчивые к городской среде.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/improvement/yards-parks.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Пространства для игр и отдыха',
      'Мы создаём тематические пространства с уникальным дизайном для жителей всех возрастов: PlayHub — современные и безопасные площадки, MultiHub — мультифункциональные пространства с продуманным зонированием',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/improvement/space-for-games.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Места для спорта',
      'SportHub — современные пространства для занятий спортом с продуманным зонированием, которые идеально подходят для любителей активного отдыха',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/improvement/places-for-sports.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Пешеходные бульвары',
      'Пешеходный бульвар — центральный элемент кварталов ПИК. Здесь находятся зоны для прогулок, велодорожки и озеленение. Продуманное зонирование создаёт комфортную среду без машин для жизни и общения.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/improvement/pedestrian-boulevards.jpg',
    ),
  ]),
  new SliderBlockTypeOneModel(new ChipsOption('Инфраструктура'), [
    new SliderBlockTypeOneSlideModel(
      'Школы будущего',
      'В наших кварталах мы создаём все условия для развития детей. В школах действуют инновационные программы обучения и современные пространства для творчества и спорта.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/infrastructure/schools-of-the-future.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Детские сады',
      'Пространства, где создана гармоничная среда для раскрытия потенциала ребёнка: современные программы, продуманное зонирование и места для творчества',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/infrastructure/kindergartens.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Поликлиники',
      'Поликлиники с современным оборудованием и продуманной навигацией всегда находятся рядом с домом. Здоровье жителей — один из приоритетов при строительстве новых проектов.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/infrastructure/polyclinics.jpg',
    ),
  ]),
  new SliderBlockTypeOneModel(new ChipsOption('Коммерческая недвижимость'), [
    new SliderBlockTypeOneSlideModel(
      'Коммерческие помещения',
      'В каждом квартале мы создаём комфортную среду для развития бизнеса: наши помещения подойдут для кафе, магазинов или других полезных сервисов',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/commercial-real-estate/commercial-premises.jpg',
    ),
  ]),
  new SliderBlockTypeOneModel(new ChipsOption('Культура'), [
    new SliderBlockTypeOneSlideModel(
      'Сохранение культурного наследия',
      'ПИК восстанавливает памятники культуры, бережно сохраняя связь с историей. Старые здания обретают новую жизнь благодаря сочетанию традиционных технологий и инноваций.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/culture/preservation-of-cultural-heritage.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Новая жизнь памятников культуры',
      'Исторические здания обретают полезные функции для жителей. Обновлённые объекты гармонично встраиваются в городскую среду, становятся местами для отдыха, музеями, картинными галереями и школами.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/culture/new-life-for-cultural-monuments.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Школа «Лермонтовский 54»',
      'Объект культурного наследия, где в XIX веке располагалось старейшее в России кавалерийское училище. Мы бережно отреставрировали историческое пространство, наполнив его современными образовательными технологиями.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/culture/school-Lermontovsky-54.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Образовательный центр в «Кантемировская 11»',
      'Памятник архитектуры начала XX века преобразился в современное образовательное пространство с VR-лабораториями, интерактивными классами',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/culture/educational-center-in-Kantemirovskaya-11.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Водонапорная башня в «Яуза парк»',
      'Отреставрированная башня XIX века с аутентичными фасадами и стальными конструкциями станет частью общественного пространства в «Яуза парке»',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/culture/water-tower-in-Yauza-Park.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Культурное наследие в Бурятии',
      'ПИК реставрирует 13 исторических деревянных домов в Улан-Удэ, соединяя историческое наследие Бурятии с жизнью современного города',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/culture/cultural-heritage-of-buryatia.jpg',
    ),
  ]),
]);

export const sliderBlockTypeOneSlideServiceV2 = new SliderBlockTypeOneSlideService([
  new SliderBlockTypeOneModel(new ChipsOption('Благоустройство'), [
    new SliderBlockTypeOneSlideModel(
      'Парк во дворе',
      'Во дворах-парках тихо и уютно: здесь много зелени, нет машин, а площадки для шумных видов спорта, например баскетбола или футбола, расположены с другой стороны домов.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business_v2/improvement/park-in-the-yard.webp',
    ),
    new SliderBlockTypeOneSlideModel(
      'Пространства для игр и отдыха',
      'Мы создаём тематические пространства с уникальным дизайном для жителей всех возрастов: ПлейХаб — тематическая площадка с оригинальным оборудованием и ландшафтом, МультиХаб - мультифункциональные пространства с продуманным зонированием.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business_v2/improvement/space-for-games.webp',
    ),
    new SliderBlockTypeOneSlideModel(
      'Места для спорта',
      'СпортХаб — современные пространства для занятий спортом с функциональными зонами, которые идеально подходят для любителей активного отдыха.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business_v2/improvement/places-for-sports.webp',
    ),
    new SliderBlockTypeOneSlideModel(
      'Пешеходные бульвары',
      'Пешеходный бульвар — центральный элемент кварталов ПИК. Здесь находятся зоны для прогулок, велодорожки и озеленение. Мы создаем комфортную среду без машин для жизни и общения.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business_v2/improvement/pedestrian-boulevards.webp',
    ),
  ]),
  new SliderBlockTypeOneModel(new ChipsOption('Образование и здоровье'), [
    new SliderBlockTypeOneSlideModel(
      'Инновационные школы',
      'Мы непрерывно совершенствуем подходы к созданию образовательных объектов. Вместе с ведущими компаниями и образовательными партнерами мы разрабатываем уникальные программы и форматы обучения, интегрируя лучшие практики.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business_v2/education-and-health/innovative-schools.webp',
    ),
    new SliderBlockTypeOneSlideModel(
      'Детские сады',
      'В наших детских садах малыши получают всё, что нужно для развития и самореализации. Здесь они играют, познают удивительный мир вокруг, учатся общаться и взаимодействовать друг с другом.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business_v2/education-and-health/kindergartens.webp',
    ),
    new SliderBlockTypeOneSlideModel(
      'Поликлиники',
      'Медицинские учреждения проектируются по высоким стандартам: современные интерьеры, продуманная навигация и светлые кабинеты обеспечивают комфорт пациентов и качественную медицинскую помощь.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business_v2/education-and-health/polyclinics.webp',
    ),
  ]),
  new SliderBlockTypeOneModel(new ChipsOption('Коммерческая недвижимость'), [
    new SliderBlockTypeOneSlideModel(
      'Коммерческие помещения',
      'Мы создаём комфортную среду для жителей и бизнеса. Коммерческие помещения в квартале подходят для открытия кафе, магазинов, аптек и других полезных сервисов.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business_v2/commercial-real-estate/commercial-premises.webp',
    ),
    new SliderBlockTypeOneSlideModel(
      'Продуманная концепция',
      'В основе концепции — сбалансированная экосистема услуг. Мы тщательно подбираем ключевых арендаторов, чтобы жители получали всё необходимое рядом с домом, а у коммерческих помещений была постоянная аудитория.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business_v2/commercial-real-estate/thoughtful-concept.webp',
    ),
    new SliderBlockTypeOneSlideModel(
      'Торговые аллеи',
      'Панорамные витрины выходят на пешеходные аллеи, где проходят основные маршруты. Вместе они образуют торговые аллеи для прогулок и шопинга.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business_v2/commercial-real-estate/shopping-alleys.webp',
    ),
    new SliderBlockTypeOneSlideModel(
      'Деловая среда',
      'В кварталах с деловыми кластерами жители получают новые рабочие места, а бизнес — аудиторию и дополнительный поток клиентов.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business_v2/commercial-real-estate/business-environment.webp',
    ),
  ]),
  new SliderBlockTypeOneModel(new ChipsOption('Паркинг и кладовые'), [
    new SliderBlockTypeOneSlideModel(
      'Машино-места',
      'На территории проектов мы предусмотрели подземные и наземные паркинги: с ними не придётся искать, где поставить машину или мотоцикл.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business_v2/parking-and-storage/parking-spaces.webp',
    ),
    new SliderBlockTypeOneSlideModel(
      'Кладовые',
      'На подземных этажах расположены вместительные кладовые. В них можно хранить крупногабаритные вещи, которые занимают много места в квартире. Спуститься к индивидуальным кладовым получится на лифте с любого этажа.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business_v2/parking-and-storage/storage-rooms.webp',
    ),
  ]),
]);
